export default __webpack_public_path__ + "static/media/up.f11002e7.svg";